import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';
import * as Accordion from '@radix-ui/react-accordion';

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: calc(100vh - 68px);
  background-color: ${({ theme }) => theme.colors.white};
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 850px;
  padding: 24px 0 0;
  gap: 16px;
`;

const NavigationContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const NavLink = styled.div<{
  $isActive: boolean;
}>`
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.black : theme.colors.darkGray};

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    margin-top: 16px;
    background-color: ${({ theme }) => theme.colors.secondary};
    visibility: ${({ $isActive }) => ($isActive ? 'visible' : 'hidden')};
  }
`;

const Body = styled.div`
  width: 100%;
  max-width: 850px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 0 48px;
`;

const Textarea = styled.textarea`
  width: 100%;
  min-height: 220px;
  padding: 16px;
  border: 1px solid #cbcbcb;
  border-radius: 4px;
  font-family: inherit;
  font-size: 16px;
  resize: vertical;
`;

const PlaceholderList = styled.ul`
  margin: 0;
  padding-left: 20px;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 14px;
  line-height: 1.6;
`;

const EditorContainer = styled.div`
  .ql-container {
    font-family: Helvetica Neue, sans-serif;
    font-size: 16px;
    background-color: #fff;
  }

  .ql-editor {
    min-height: 220px;
  }
`;

const Footer = styled.div`
  display: flex;
  gap: 16px;
`;

const TopicAccordion = styled(Accordion.Root)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TopicItem = styled(Accordion.Item)`
  border: 1px solid #cbcbcb;
  border-radius: 4px;
  overflow: hidden;
`;

const TopicChevron = styled(UIElements.Icon)`
  transition: transform 200ms ease;
`;

const TopicTrigger = styled(Accordion.Trigger)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;

  &[data-state='open'] ${TopicChevron} {
    transform: rotate(180deg);
  }
`;

const TopicContent = styled(Accordion.Content)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 20px 20px;
  border-top: 1px solid #cbcbcb;
`;

const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 16px;
`;

const FieldHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

const VariantTabs = styled.div`
  display: flex;
  gap: 8px;
`;

const VariantTab = styled.button<{ $isActive: boolean }>`
  border: 1px solid
    ${({ theme, $isActive }) =>
      $isActive ? theme.colors.secondary : '#cbcbcb'};
  background: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.secondary : theme.colors.white};
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.white : theme.colors.darkGray};
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const S = {
  ...UIElements,
  Page,
  Header,
  NavigationContainer,
  NavLink,
  Body,
  Textarea,
  PlaceholderList,
  EditorContainer,
  Footer,
  TopicAccordion,
  TopicItem,
  TopicTrigger,
  TopicContent,
  TopicChevron,
  FieldBlock,
  FieldHeader,
  VariantTabs,
  VariantTab,
};
